import { reducer as privacyPolicyReducer } from './slice';

export * from './actions';
export * from './middlewares';

export default privacyPolicyReducer;
